import { FC, useState } from 'react';
import { useSelector } from 'react-redux';

import { motion } from 'framer-motion';

import { selectActiveUserId } from 'features/applications/applicationsSelectors';
import applicationsService from 'features/applications/applicationsService';

import useErrorCatch from 'hooks/useErrorCatch';

import { GTMEventLogger } from 'utils/analytics';

import { InterviewDetails } from 'types/interviewSlots';

import { GTMEvents } from 'constants/enums';

import CancelInterviewConfirmation from '../CancelInterviewConfirmation/CancelInterviewConfirmation';
import PendingConfirmation from '../PendingConfirmation/PendingConfirmation';

interface AwaitingResponseProps {
  interviewRequest: InterviewDetails;
  onActionCompleted: () => void;
  isLoading: boolean;
  onLoading: (isLoading: boolean) => void;
}

const AwaitingResponse: FC<AwaitingResponseProps> = ({
  interviewRequest,
  onActionCompleted,
  isLoading,
  onLoading
}) => {
  const catchError = useErrorCatch();
  const [showCancelConfirmation, setShowCancelConfirmation] = useState(false);
  const applicationId = useSelector(selectActiveUserId);

  const handleCancelInterview = async () => {
    try {
      onLoading(true);
      await applicationsService.cancelInterview(
        applicationId,
        interviewRequest.id
      );
      onActionCompleted?.();

      GTMEventLogger(GTMEvents.ApplicationsListViewSidebarInterviewCanceled);
    } catch (error) {
      catchError({ error });
    } finally {
      onLoading(false);
    }
  };

  return (
    <motion.div layout>
      {showCancelConfirmation ? (
        <CancelInterviewConfirmation
          onBackClick={() => setShowCancelConfirmation(false)}
          onConfirm={handleCancelInterview}
          isLoading={isLoading}
        />
      ) : (
        <PendingConfirmation
          onCancelClick={() => setShowCancelConfirmation(true)}
        />
      )}
    </motion.div>
  );
};

export default AwaitingResponse;
